import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatePartnerService } from './update/update-partner.service';
import { DisablePartnerEmployeeNotificationService } from './disable-partner-employee-notification/disable-partner-employee-notification.service';
import { EnablePartnerEmployeeNotificationService } from './enable-partner-employee-notification/enable-partner-employee-notification.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    EnablePartnerEmployeeNotificationService,
    DisablePartnerEmployeeNotificationService,
    UpdatePartnerService
  ],
})
export class PartnersModule {}
